import script from "./schoolDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./schoolDetail.vue?vue&type=script&setup=true&lang=js"

import "./schoolDetail.vue?vue&type=style&index=0&id=f508534e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f508534e"]])

export default __exports__